import { BigNumber } from 'bignumber.js';
import { findRule, formatRule, formatRuleToParts, } from './numeric-format-rule.js';
export const PRESET_MAP = {
    'currency-amount-short': [
        {
            upperBound: 0.1,
            options: {
                compactDecimalZeroes: true,
                compactDecimalZeroesThreshold: 3,
                compactDecimalZeroesRemainingPartLength: 2,
                mantissa: 4,
                trimMantissa: true,
            },
        },
        {
            upperBound: Infinity,
            options: {
                compact: true,
                maximumSignificantDigits: 3,
            },
        },
    ],
    'splash-points': [
        {
            upperBound: 10_000,
            options: {
                mantissa: 0,
                trimMantissa: true,
                roundingMode: 'floor',
            },
        },
        {
            upperBound: Infinity,
            options: {
                mantissa: 0,
                compact: true,
                roundingMode: 'floor',
            },
        },
    ],
    'amount-max-5-digits': [
        {
            upperBound: 1,
            options: {
                compactDecimalZeroes: true,
                compactDecimalZeroesThreshold: 4,
                compactDecimalZeroesRemainingPartLength: 3,
                mantissa: 4,
                trimMantissa: true,
            },
        },
        {
            upperBound: 10_000,
            options: {
                mantissa: 2,
                trimMantissa: true,
            },
        },
        {
            upperBound: 100_000,
            options: {
                mantissa: 1,
                trimMantissa: true,
            },
        },
        {
            upperBound: Infinity,
            options: {
                compact: true,
                mantissa: 1,
            },
        },
    ],
    full: [
        {
            upperBound: Infinity,
            options: {
                mantissa: 32,
                trimMantissa: true,
            },
        },
    ],
    'amount-precise': [
        {
            upperBound: 1,
            options: {
                compactDecimalZeroes: true,
                compactDecimalZeroesThreshold: 4,
                compactDecimalZeroesRemainingPartLength: 4,
                mantissa: 32,
                trimMantissa: true,
            },
        },
        {
            upperBound: Infinity,
            options: {
                compact: false,
                mantissa: 32,
            },
        },
    ],
    'trend-change-percents': [
        {
            upperBound: 1,
            options: {
                mantissa: 2,
                trimMantissa: true,
            },
        },
        {
            upperBound: 100,
            options: {
                mantissa: 1,
                trimMantissa: true,
            },
        },
        {
            upperBound: 1000,
            options: {
                mantissa: 0,
                trimMantissa: true,
            },
        },
        {
            upperBound: Infinity,
            options: {
                mantissa: 1,
                trimMantissa: true,
                compact: true,
                compactDecimalZeroesRemainingPartLength: 1,
            },
        },
    ],
    'fee-usd': [
        {
            exact: BigNumber(0),
            rewriteInput: '0',
            options: {},
        },
        {
            upperBound: 0.01,
            rewriteInput: 0.01,
            options: {
                prefix: '<',
                mantissa: 2,
                trimMantissa: true,
            },
        },
        {
            upperBound: Infinity,
            options: {
                mantissa: 2,
                trimMantissa: true,
            },
        },
    ],
    percents: [
        {
            upperBound: 1,
            options: {
                mantissa: 2,
                trimMantissa: true,
            },
        },
        {
            upperBound: 100,
            options: {
                mantissa: 1,
                trimMantissa: true,
                roundingMode: 'trunc',
            },
        },
        {
            upperBound: 1000,
            options: {
                mantissa: 0,
                trimMantissa: true,
                roundingMode: 'trunc',
            },
        },
        {
            upperBound: Infinity,
            options: {
                roundingMode: 'trunc',
                compact: true,
                maximumSignificantDigits: 3,
            },
        },
    ],
};
export const preset = (preset) => PRESET_MAP[preset];
export const formatPresetToParts = (input, preset, options) => {
    const rule = findRule(input, typeof preset === 'string' ? PRESET_MAP[preset] : preset);
    if (!rule) {
        return [];
    }
    return formatRuleToParts(input, rule, options);
};
export const formatPreset = (input, preset, options) => {
    const rule = findRule(input, typeof preset === 'string' ? PRESET_MAP[preset] : preset);
    if (!rule) {
        return '';
    }
    return formatRule(input, rule, options);
};
// MARKET CAP ne sokrachat
// TP:P SL:P, TP:MC SL:MC
//# sourceMappingURL=numeric-format-presets.js.map